import { gql } from 'apollo-angular'

export const VERIFY_USER = gql`
  mutation VerifyUser($data: VerifyUserInput!) {
    verifyUser(data: $data) {
      checkoutUrl
      purchaseId
      verified
    }
  }
`
